import { QueryHookOptions, useQuery } from '@apollo/client';
import { GET_SUMMARY_TOOLBAR_STATS_QUERY } from '@frontend/app/queries/GetSummaryToolbarStats';
import { GetSummaryToolbarStatsQuery, GetSummaryToolbarStatsQueryVariables } from '../queries/types/GetSummaryToolbarStatsQuery';

type IOptions = QueryHookOptions<GetSummaryToolbarStatsQuery, GetSummaryToolbarStatsQueryVariables>;

export const useGetSummaryToolbarStats = (options: IOptions = {}) => {
  const { data, loading, error } = useQuery(GET_SUMMARY_TOOLBAR_STATS_QUERY, options);

  return {
    summaryToolbarStats: data,
    isSummaryToolbarStatsLoading: loading,
    summaryToolbarStatsError: error,
  };
};
